import pino, { type Logger } from 'pino'

const isDevelopment = process.env.NODE_ENV === 'development'

export const logger: Logger = pino({
  level: process.env.PINO_LOG_LEVEL || 'info',
  browser: {
    asObject: true,
  },
  // Only use pino-pretty in development, use JSON in production (Vercel)
  ...(isDevelopment && {
    transport: {
      target: 'pino-pretty',
      options: {
        colorize: true,
      },
    },
  }),
  // Redact sensitive information
  redact: {
    paths: ['req.headers.authorization', 'req.headers.cookie', '*.password', '*.token'],
    remove: true,
  },
})
